// Keep the legacy export names because they are used across order detail and
// submit-history code. This module intentionally has no UI dependencies.
export enum orderManuscriptState {
  Collaboration_established = "Collaboration_established",
  Deal_confirmed = "Deal_confirmed",
  Script_Submit = "ScriptSubmit",
  KickOff = "KickOff",
  Address = "Address",
  Script = "Script",
  ProductionKickoff = "ProductionKickoff",
  Creator_Address = "CreatorAddress",
  Script_Approve = "ScriptApprove",
  Draft_1 = "Draft_1",
  Draft_2 = "Draft_2",
  Draft_3 = "Draft_3",
  Draft_4 = "Draft_4",
  Draft_5 = "Draft_5",
  Final = "Final",
  Draft_1_Submit = "Draft_1_Submit",
  Draft_2_Submit = "Draft_2_Submit",
  Draft_3_Submit = "Draft_3_Submit",
  Draft_4_Submit = "Draft_4_Submit",
  Draft_5_Submit = "Draft_5_Submit",
  FinalSubmit = "FinalSubmit",
  Collaboration_cancelled = "Collaboration_cancelled",
  CreatorAccountInfo = "CreatorAccountInfo",
  AccountInfo = "AccountInfo",
  AccountSetup = "AccountSetup",
  AhaPicksOffer_sendoffer = "AhaPicksOffer_sendoffer",
  AhaPicksOffer_sendquote = "AhaPicksOffer_sendquote",
  AhaPicksOffer_quoteDeclined = "AhaPicksOffer_quoteDeclined",
}

// 到货节点 stage 值，仅前端使用。
export const Product_arrived = "Product_arrived";

export const orderManuscriptStateTitle: Record<string, string> = {
  [orderManuscriptState.Collaboration_established]:
    "orderDetail.manuscriptStates.influencerApplied",
  [orderManuscriptState.Deal_confirmed]:
    "orderDetail.manuscriptStates.dealConfirmed",
  [orderManuscriptState.AhaPicksOffer_sendoffer]:
    "orderDetail.manuscriptStates.ahaPicksOffer_sendoffer",
  [orderManuscriptState.AhaPicksOffer_sendquote]:
    "orderDetail.manuscriptStates.ahaPicksOffer_sendquote",
  [orderManuscriptState.AhaPicksOffer_quoteDeclined]:
    "orderDetail.manuscriptStates.ahaPicksOffer_quoteDeclined",
  [orderManuscriptState.KickOff]:
    "orderDetail.manuscriptStates.kickoffProduction",
  [orderManuscriptState.Address]:
    "orderDetail.manuscriptStates.productShipped",
  [Product_arrived]: "orderDetail.manuscriptStates.productArrived",
  [orderManuscriptState.AccountInfo]:
    "orderDetail.manuscriptStates.submitAccount",
  [orderManuscriptState.AccountSetup]:
    "orderDetail.manuscriptStates.submitAccount",
  [orderManuscriptState.Script]: "orderDetail.manuscriptStates.script",
  [orderManuscriptState.Draft_1]:
    "orderDetail.manuscriptStates.videoDraft1",
  [orderManuscriptState.Draft_2]:
    "orderDetail.manuscriptStates.videoDraft2",
  [orderManuscriptState.Draft_3]:
    "orderDetail.manuscriptStates.videoDraft3",
  [orderManuscriptState.Draft_4]:
    "orderDetail.manuscriptStates.videoDraft4",
  [orderManuscriptState.Draft_5]:
    "orderDetail.manuscriptStates.videoDraft5",
  [orderManuscriptState.Final]: "orderDetail.manuscriptStates.finalLink",
  [orderManuscriptState.Collaboration_cancelled]:
    "orderDetail.manuscriptStates.applicationRejected",
};
